module.exports = __webpack_public_path__ + "static/media/1-12things-print.b577ea9e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/1-12things-print.pdf
// module id = 155
// module chunks = 0